import Vue from 'vue';
import { featureIntros } from '@/constants';
import { Plugins } from '@capacitor/core';
const { Device } = Plugins;

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

import Image1 from '../assets/img/login-page-images/AFF.png';
import Image2 from '../assets/img/login-page-images/birthday.png';
import Image3 from '../assets/img/login-page-images/sms_nletter2.png';
import Image4 from '../assets/img/login-page-images/workfhome.png';
import Image5 from '../assets/img/login-page-images/WORKH.png';

let featureImages = [Image1, Image2, Image3, Image4, Image5];
/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

let intlPhoneFormat = function (phoneNos, zipCode) {
  phoneNos = Vue.lodash.replace(phoneNos, new RegExp('\n', 'g'), ',');
  phoneNos = Vue.lodash.replace(phoneNos, new RegExp(':', 'g'), ',');
  phoneNos = Vue.lodash.replace(phoneNos, new RegExp(';', 'g'), ',');
  phoneNos = phoneNos.split(' ').join('');
  phoneNos = phoneNos.split('.').join('');
  phoneNos = phoneNos.split('-').join('');

  let phoneNosArr = phoneNos.split(',');

  let intlPhones = [];

  phoneNosArr.forEach(function (phoneNo) {
    phoneNo = Vue.lodash.trimStart(phoneNo, '+');
    phoneNo = Vue.lodash.trimStart(phoneNo, '0');

    if (Vue.lodash.startsWith(phoneNo, zipCode) || phoneNo.length >= 11) {
      intlPhones.push(phoneNo);
    } else if (phoneNo != '') {
      intlPhones.push(zipCode + phoneNo);
    }
  });

  return intlPhones.join(',');
};
export { intlPhoneFormat };

let getRecurrenceById = function (id) {
  switch (id) {
    case 0:
      return 'Daily';
    case 1:
      return 'Weekly';
    case 2:
      return 'Monthly';
  }
};
export { getRecurrenceById };

let numberWithCommas = function (x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export { numberWithCommas };

let formatDate = function (date) {
  if (date.length > 16) {
    date = Vue.lodash
      .truncate(date, { length: 16, omission: '' })
      .replace('T', ' ');
  }

  return date;
};
export { formatDate };

let monthNameById = function (id) {
  let formatedVal = '';
  switch (id) {
    case 1:
      formatedVal = 'January';
      break;
    case 2:
      formatedVal = 'February';
      break;
    case 3:
      formatedVal = 'March';
      break;
    case 4:
      formatedVal = 'April';
      break;
    case 5:
      formatedVal = 'May';
      break;
    case 6:
      formatedVal = 'June';
      break;
    case 7:
      formatedVal = 'July';
      break;
    case 8:
      formatedVal = 'August';
      break;
    case 9:
      formatedVal = 'September';
      break;
    case 10:
      formatedVal = 'October';
      break;
    case 11:
      formatedVal = 'November';
      break;
    case 12:
      formatedVal = 'December';
      break;
  }
  return formatedVal;
};
export { monthNameById };

let smsPages = function (content) {
  const MAX_SINGLE = 160;
  const MAX_MULTIPLE = 151;
  let pageLen = content.length <= MAX_SINGLE ? MAX_SINGLE : MAX_MULTIPLE;
  let pages = Math.ceil(content.length / pageLen);

  return pages;
};
export { smsPages };

let randomFeatureIntro = function () {
  return featureIntros[random(0, featureIntros.length - 1)];
};
export { randomFeatureIntro };

let randomFeatureImages = function () {
  return featureImages[random(0, featureImages.length - 1)];
};
export { randomFeatureImages };

let isMobileDevice = async function () {
  const info = await Device.getInfo();
  return info.operatingSystem == 'android' || info.operatingSystem == 'ios';
};

export { isMobileDevice };
